import { supabase } from './supabase.js'

/**
 * Auth is thin on purpose. One account, his own, signed in once on the phone
 * and kept alive by autoRefreshToken. Everything under RLS depends on this
 * session existing, so if it is missing the app shows the sign-in screen
 * rather than making calls that will be refused.
 */

export async function getSession() {
  const { data, error } = await supabase.auth.getSession()
  if (error) throw error
  return data.session ?? null
}

/** Fires on sign in, sign out, and every token refresh. Returns an unsubscribe. */
export function onAuthChange(handler) {
  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    handler(session ?? null)
  })
  return () => data.subscription.unsubscribe()
}

export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  })
  if (error) throw error
  return data.session
}

/**
 * Only needed the first time, and only if the account was not created for him
 * on the Supabase side. If the project requires email confirmation, Supabase
 * returns a user with no session — the caller has to say so plainly rather
 * than leaving him on a screen that looks stuck.
 */
export async function signUp(email, password) {
  const { data, error } = await supabase.auth.signUp({
    email: email.trim(),
    password,
  })
  if (error) throw error
  return { session: data.session, needsConfirmation: !data.session }
}

export async function signOut() {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}
